<template>
  <el-row
      v-if="adStore.SP.campaign || adStore.SP.group"
      v-gutter="8"
      type="flex"
      align="middle"
      class="current-position">
    <template v-if="adStore.SP.campaign && adStore.SP.group">
      <gj-breadcrumb :list="breadcrumbList" @backHandle="toCampaignManager"></gj-breadcrumb>
      <!--      <div>-->
      <!--        <gj-link @click="toCampaignManager">-->
      <!--          <gj-icon iconfont="iconback" class="return-icon"></gj-icon>-->
      <!--        </gj-link>-->
      <!--        <gj-link @click="toCampaignManager">-->
      <!--          <span class="current-position&#45;&#45;text">{{adStore.SP.campaign.campaignName | defaultShow}}</span>-->
      <!--        </gj-link>-->
      <!--        <span class="current-position&#45;&#45;text">/</span>-->
      <!--        <span class="current-position&#45;&#45;text">{{adStore.SP.group.groupName | defaultShow}}</span>-->
      <!--      </div>-->
    </template>
    <template v-else-if="adStore.SP.campaign">
      <gj-breadcrumb :list="breadcrumbList" @backHandle="toAdManager"></gj-breadcrumb>
      <!--      <div>-->
      <!--        <gj-link @click="toAdManager">-->
      <!--          <gj-icon iconfont="iconback" class="return-icon"></gj-icon>-->
      <!--        </gj-link>-->
      <!--        <span class="current-position&#45;&#45;text">{{adStore.SP.campaign.campaignName | defaultShow}}</span>-->
      <!--      </div>-->
    </template>
  </el-row>
</template>

<script>
import {adStore} from "../../../common/store";

export default {
  name: "app-sp-ad-navigator",
  data() {
    return {
      adStore: adStore,
      breadcrumbList: []
    }
  },

  watch: {
    'adStore.SP.campaign': {
      immediate:true,
      handler: function (n, o) {
        // console.log(this.adStore.SP)
        if (n) {
          this.breadcrumbList = [
            {
              name: this.adStore.SP.campaign?.campaignName || '',
              handle: () => {}
            }
          ]
        }
      },
    },
    'adStore.SP.group': {
      immediate:true,
      handler: function (n, o) {
        if (n) {
          this.breadcrumbList = [
            {
              name: this.adStore.SP.campaign?.campaignName || '',
              handle: () => {this.toCampaignManager()}
            },
            {
              name: this.adStore.SP.group?.groupName || '',
              handle: () => {}
            }
          ]
        } else {
          this.breadcrumbList = [
            {
              name: this.adStore.SP.campaign?.campaignName || '',
              handle: () => {}
            }
          ]
        }
      }
    }
  },
  methods: {
    toAdManager() {
      this.adStore.SP.campaign = null;
      this.adStore.SP.group = null;
    },
    toCampaignManager() {
      this.adStore.SP.group = null;
    }
  }
}
</script>

<style scoped lang="scss">
.current-position {
  padding: 16px 0 0 0;
}

.current-position--text,
.return-icon {
  font-size: 12px;
  color: #888;
  margin-right: 8px;
}

.current-position--text {
  line-height: 12px;
}
/deep/.gj-breadcrumb {
  div {
    line-height: 1;
  }
}
</style>
